<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">发票管理</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="3" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="col90 fs18 mb35">管理中的发票：<span class="fwb" :class="invoiceList.length > 0 ? 'col12' : 'col90'">{{
                    invoiceList.length
                }}</span> 份</div>
                <div class="flex-box mb55">
                    <div class="input_box flex-box">
                        <input type="text" class="flex-grow-1 fs14" placeholder="搜索我的发票" v-model="q">
                        <div class="cursor search_btn fs14">搜索</div>
                    </div>
                    <router-link to="/InvoiceGoods" class="flex-box go_open fs14 col12 cursor">继续去开票</router-link>
                </div>
                <!-- <div class="status_box flex-box fs18">
                    <div class="col90">发票状态</div>
                    <div class="status active">全部</div>
                    <div class="status">已开票</div>
                    <div class="status">开票中</div>
                    <div class="status">开票失败</div>
                </div> -->
                <template v-if="invoiceList.length > 0">
                    <div class="title_box flex-box fs14 col04">
                        <div class="box1">公司抬头</div>
                        <div class="box2 tc">开票主体</div>
                        <div class="box3 tc">金额</div>
                        <div class="flex-grow-1 tc">状态</div>
                    </div>
                    <div class="invoice_item flex-box fs14 col04" v-for="(item, index) in invoiceList" :key="index">
                        <div class="box1">
                            <div class="mb10">{{ item.invoice_heard }}</div>
                            <div class="fs14 col90"> {{ formatDate(item.createtime * 1000) }}</div>
                        </div>
                        <div class="box2 tc m-ellipsis-l2">{{ item.institution ? item.institution.company_name : '无' }}
                        </div>
                        <div class="box3 tc col90">共计：<span class="coleb">¥ {{ item.invoice_money }}</span></div>
                        <div class="flex-grow-1 tc">
                            <span class="status1 cursor" @click="toDetail(item)" v-if="item.invoice_status == 1">已开票</span>
                            <span class="status2" v-if="item.invoice_status == 0">开票中</span>
                            <span class="status3 cursor" @click="popShow = true" v-if="item.invoice_status == 2">开票失败</span>
                        </div>
                    </div>
                </template>
                <div v-if="invoiceList.length == 0" class="nodata fs16 tc">
                    <img src="../../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
                    <div>暂无相关数据</div>
                </div>
                <pagination :sumCount="sumCount" :perCount="perCount" @pageTurn="pageTurn" v-show="sumCount > perCount">
                </pagination>
            </div>
        </div>
    </div>
    <popup :visible="popShow" @close="popShow = false">
        <div class="intro_pop ">
            <img src="../../../assets/static/icon/c_pop_close.png" class="c_pop_close" @click="popShow = false" alt="">
            <div class="article">
                <img src="../../../assets/static/icon/c_fail.png" class="c_fail" alt="">
                <div class="fs22 col04 tc mb15">开票说明</div>
                <div class="fs16 col90 tc">请核对并修改以下信息后，再重新提交。</div>
                <div class="reason_box">
                    <div class="fs18 col90 pb10">您的开票失败原因为：</div>
                    <div class="fs16 col3 fwb">
                        这里是开票失败原因这里是开票失败原因这里是开票失败原因这里是开票失败原因这里是开票失败原因这里是开票失败原因这里是开票失败原因这里是开票失败原因这里是开票失败原因</div>
                </div>
                <div class="change fs18 tc cursor">去修改</div>
            </div>
        </div>
    </popup>
</template>

<script>
import moment from "moment";
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "发票管理-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            invoiceList: [],
            popShow: false,
            page: 1,
            sumCount: 0,
            perCount: 10,
            q: '',
        };
    },
    created() {
        this.getList();
    },
    methods: {
        toDetail(item) {
            let url = item.red_url ? item.red_url : item.c_jpg_url;
            //this.$router.push({ path: '/InvoiceDetail', query: { url: encodeURIComponent(url) } });
            if(url){
                location.href = url;
            }
        },
        //格式化日期
        formatDate(timestamp) {
            return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
        },
        // 获取发票列表
        getList() {
            this.$api.getInvoiceList({
                page: this.page,
                q: this.q,
            }).then(res => {
                this.invoiceList = res.data.data;
                this.sumCount = res.data.total;
                this.perCount = res.data.per_page;
            })
        },
        // 分页
        pageTurn(e) {
            this.page = e + 1;
            this.getList();
        }
    },
};
</script>

<style lang="less" scoped>
.part_r {
    padding: 41px 44px 100px;
    background: #fff;

    .input_box {
        width: 468px;
        height: 40px;
        border-radius: 8px;
        border: 2px solid #3d7efe;
        padding-left: 20px;

        &::before {
            content: "";
            display: block;
            background: url("/src/assets/static/icon/c_search.png") no-repeat center;
            background-size: 100%;
            width: 22px;
            height: 22px;
            margin-right: 10px;
        }

        input {
            height: 52px;
        }

        .search_btn {
            width: 80px;
            height: 40px;
            border-radius: 8px;
            background: #1275ff;
            text-align: center;
            line-height: 40px;
            margin: -1px -1px 0 0;
            color: #ffffff;
            font-weight: 400;
            letter-spacing: 4.090909px;
        }
    }

    .go_open {
        margin-left: 104px;

        &::after {
            content: "";
            display: block;
            width: 12px;
            height: 12px;
            background: url('/src/assets/static/icon/c_continue.png') no-repeat center;
            background-size: 100%;
            margin-left: 5px;
        }
    }

    .status_box {
        .col90 {
            margin-right: 46px;
        }

        .status {
            padding: 0 46px;
            color: #040404;
            cursor: pointer;

            &.active {
                color: #3d7efe;
            }
        }
    }

    .title_box {
        height: 50px;
        background: #fafcff;
        margin-top: 42px;
    }

    .invoice_item {
        height: 80px;
        border-bottom: 1px solid #c0cfdd;
    }

    .box1 {
        padding-left: 40px;
        width: 286px;
    }

    .box2 {
        width: 220px;
    }

    .box3 {
        width: 367px;
    }

    .status1 {
        color: #00C800;
    }

    .status2 {
        color: #1275FF;
    }

    .status3 {
        color: #EB3F25;
    }
}

.intro_pop {
    background: url('/src/assets/static/icon/c_intro_bg2.png') no-repeat center;
    height: 569px;
    padding-top: 37px;
    background-size: 698px 569px;

    .c_fail {
        width: 66px;
        height: 66px;
        display: block;
        margin: 80px auto 24px;
    }

    .reason_box {
        width: 598px;
        background: #FBFCFD;
        border-radius: 8px;
        margin: 24px auto;
        padding: 24px 30px;
    }

    .change {
        width: 598px;
        height: 50px;
        background: #3D7EFE;
        border-radius: 8px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 50px;
        margin: 0 auto;
    }
}
</style>
